import { Action, Reducer } from 'redux';
import { ResponseCachingState } from './types-store';
import { ACTION, RequestUiDefinition, ReceiveUiDefinition, FailUiDefinition } from './action-types';

export const INITIAL_UI_DEFINITION_STATE: ResponseCachingState = {
  uiDefinitions: []
};

const reducers: { [indexer: string]: Reducer<ResponseCachingState, Action> } = {

  [ACTION.REQUEST_UI_DEFINITION]: (state: ResponseCachingState, action: RequestUiDefinition): ResponseCachingState => {

    return {
      ...state,
      uiDefinitions: [
        ...state.uiDefinitions.filter(ui => !(ui.id === action.caseTypeId && ui.caseContextId === action.caseContextId)),
        {
          id: action.caseTypeId,
          caseContextId: action.caseContextId,
          fetching: true
        }
      ]
    };
  },

  [ACTION.RECEIVE_UI_DEFINITION]: (state: ResponseCachingState, action: ReceiveUiDefinition): ResponseCachingState => {

    return {
      ...state,
      uiDefinitions: [
        ...state.uiDefinitions.filter(ui => !(ui.id === action.caseTypeId && ui.caseContextId === action.caseContextId)),
        {
          id: action.caseTypeId,
          caseContextId: action.caseContextId,
          fetching: false,
          definition: action.uiDefinition,
          eTag: action.eTag,
          timestamp: new Date().getTime()
        }
      ]
    };
  },

  [ACTION.FAIL_UI_DEFINITION]: (state: ResponseCachingState, action: FailUiDefinition): ResponseCachingState => {

    return {
      ...state,
      uiDefinitions: [
        ...state.uiDefinitions.filter(ui => !(ui.id === action.caseTypeId && ui.caseContextId === action.caseContextId)),
        {
          id: action.caseTypeId,
          caseContextId: action.caseContextId,
          fetching: false
        }
      ]
    };
  }
};

export const reducer: Reducer<ResponseCachingState> = (
  state: ResponseCachingState = INITIAL_UI_DEFINITION_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
